import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { loadChartData } from 'redux/Chart/actions';
import { isNotEmptyArray, ssrHandler } from 'utils';

import ChartTemplate from './ChartTemplate';

class Chart extends PureComponent {
  render() {
    return (
      <ChartTemplate
        chartPoints={this.props.chartPoints}
        isChartFetching={this.props.isChartFetching}
      />
    );
  }
}

Chart.propTypes = {
  chartPoints: PropTypes.array,
  isChartFetching: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  chartPoints: state.chart.items,
  isChartFetching: state.chart.isFetching
});

function loadPageData(store, nextState, replace, callback) {
  const { chart } = store.getState();

  if (isNotEmptyArray(chart.items) || chart.isFetching) {
    callback();
    return;
  }

  const actions = [loadChartData()];

  ssrHandler(store.dispatch, actions, callback);
}

export default (store) => ({
  path: '/we/chart/',
  component: connect(mapStateToProps)(Chart),
  onEnter: loadPageData.bind(null, store)
});



// WEBPACK FOOTER //
// ./src/components/Chart/index.js